/**
 * Centralized configuration for API endpoints and application settings
 */

export interface ApiConfig {
  baseUrl: string;
  signalRBaseUrl: string;
}

/**
 * Gets the API configuration based on environment variables
 */
export const getApiConfig = (): ApiConfig => {
  const apiUrl = import.meta.env.VITE_API_URL || '/api';
  
  return {
    baseUrl: apiUrl,
    signalRBaseUrl: apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl
  };
};

/**
 * Singleton API configuration instance
 */
export const apiConfig = getApiConfig();

/**
 * Environment utilities
 */
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

/**
 * API endpoint builder - ensures consistent URL construction
 */
export const buildApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${apiConfig.baseUrl}/${cleanEndpoint}`;
};

/**
 * SignalR hub URL builder
 */
export const buildSignalRUrl = (hubName: string): string => {
  const cleanHubName = hubName.startsWith('/') ? hubName.slice(1) : hubName;
  return `${apiConfig.signalRBaseUrl}/${cleanHubName}`;
};